'use client';

import Image from '@/components/Image';
import { useMediaQuery } from '@mui/material';
import React from 'react';

// =================================================================
// 1. PC 端组件 (您的原始代码，未做任何修改)
// =================================================================
const MeasureDE_PC: React.FC = () => {
  return (
    <div className="w-4/5 mx-auto">
      {/* Header */}
      <h1 className="text-3xl mb-12">de</h1>

      <div className="custom_pd_outer">
        {/* Title */}
        <h2 className="text-5xl font-bold mb-40 text-gray-800">
          So messen Sie die Pupillendistanz (PD)
        </h2>

        {/* Description */}
        <p className="text-base font-normal text-gray-800 leading-24 mb-13">
          Die Pupillendistanz ist der Abstand von der Pupillenmitte bis zur Mitte der Nase. Dieser
          Wert wird in Millimeter (mm) angegeben. Bei Gleitsichtbrillen empfehlen wir dringend die
          Abmessung der PD-Werte durch einen Optiker oder Augenarzt, da bei kleinsten Abweichungen
          kein optimales Sehergebnis garantiert werden kann.
        </p>

        {/* Download PD Rule */}
        <div className="flex flex-col justify-center items-center bg-blue-50 mb-[50px] py-12  px-0 pt-[50px] pb-[39px]">
          <div className="text-base font-normal text-gray-800 leading-24 mb-[39px]">
            Laden Sie ein PD-Lineal herunter
          </div>
          <a
            rel="noopener noreferrer"
            href="https://common.xmslol.com/zeelool/pd/zeelool_de_pd_ruler.pdf"
            className="flex flex-row justify-center items-center w-[350px] h-[60px] bg-[#3c65ca] rounded-[30px] text-[18px] font-bold text-white leading-[24px] cursor-pointer hover:bg-[#2a4fa2] transition"
          >
            <Image
              src={'/static-page/guide-tips/download.png'}
              alt="Download"
              width={26}
              height={26}
              className="mr-[17px]"
            />
            Klick hier
          </a>
        </div>

        {/* Mirror Measurement Section */}
        <div className="flex flex-col justify-center items-center mb-[60px]">
          <h3 className="text-2xl font-bold text-gray-800 leading-24 mb-[20px] text-center">
            Messen Sie es vor einem Spiegel
          </h3>
          <div className="w-full max-w-2xl">
            <Image
              src="/static-page/guide-tips/pd/measure-mirror.png"
              alt="Mirror measurement"
              width={668}
              height={360}
              className="w-full h-auto"
            />
          </div>
        </div>

        {/* Friend Help Section */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-800 leading-24 mb-[20px] text-center">
            Messen Sie Ihre Pupillendistanz mit der Hilfe eines Freundes
          </h3>

          {/* Step 1 */}
          <div className="flex justify-between items-center bg-blue-50 mb-10 p-16">
            <div className="w-2/5">
              <div className="text-2xl font-bold text-gray-800 leading-24 mb-8">Schritt 1</div>
              <div className="text-sm font-normal text-gray-800 leading-24">
                Wenn Sie nur den Rahmen benötigen. (Demogläser sind im Lieferumfang enthalten)
              </div>
            </div>
            <div className="w-3/5 pl-4">
              <Image
                src="/static-page/guide-tips/pd/step1.png"
                alt="Step 1"
                width={580}
                height={276}
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 2 */}
          <div className="flex justify-between items-center bg-blue-50 mb-10 p-16">
            <div className="w-2/5">
              <div className="text-2xl font-bold text-gray-800 leading-24 mb-8">Schritt 2</div>
              <div className="text-sm font-normal text-gray-800 leading-24">
                Schließen Sie Ihr linkes Auge und lassen Sie Ihren Freund die 0 mm über der Mitte
                Ihrer rechten Pupille ausrichten
              </div>
            </div>
            <div className="w-3/5 pl-4">
              <Image
                src="/static-page/guide-tips/pd/step2.png"
                alt="Step 2"
                width={580}
                height={276}
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 3 */}
          <div className="flex justify-between items-center bg-blue-50 mb-10 p-16">
            <div className="w-2/5">
              <div className="text-2xl font-bold text-gray-800 leading-24 mb-8">Schritt 3</div>
              <div className="text-sm font-normal text-gray-800 leading-24">
                Schließen Sie Ihr rechtes Auge und öffnen Sie das linke. Lassen Sie dann Ihren
                Freund den Messwert direkt über Ihrer linken Pupille notieren. Das wird Ihre PD
                sein.
              </div>
            </div>
            <div className="w-3/5 pl-4">
              <Image
                src="/static-page/guide-tips/pd/step3.png"
                alt="Step 3"
                width={580}
                height={276}
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 4 */}
          <div className="flex justify-between items-center bg-blue-50 mb-10 p-16">
            <div className="w-2/5">
              <div className="text-2xl font-bold text-gray-800 leading-24 mb-8">Schritt 4</div>
              <div className="text-sm font-normal text-gray-800 leading-24">
                Um eine PD mit hoher Genauigkeit zu messen, führen Sie dies bitte dreimal durch und
                nehmen Sie eine durchschnittliche Anzahl davon als endgültige PD-Messung
              </div>
            </div>
            <div className="w-3/5 pl-4">
              <Image
                src="/static-page/guide-tips/pd/step4.png"
                alt="Step 4"
                width={580}
                height={276}
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>

        {/* Notes Section */}
        <div className="mb-[20px]">
          <div className="text-lg font-bold text-gray-800 leading-24 mb-5">Anmerkungen:</div>
          <div className="space-y-6">
            <div className="text-sm font-normal text-gray-800 leading-24">
              1. Die durchschnittliche PD der Erwachsener liegt zwischen 54 mm und 78 mm
              <br />
              2. Für diejenigen, die Gleitsichtgläser benötigen, empfehlen wir dringend, diese
              Informationen von Ihrem Optiker zu erhalten, um die Genauigkeit Ihrer Brille
              sicherzustellen.
              <br />
              3. Ihre PD kann auf drei Arten geschrieben werden:
              <br />
              {`· PD geschrieben als „64", bezeichnet die binokulare PD, die für beide Augen`}
              gilt.
              <br />
              {`· PD (R) bedeutet die monokulare PD für das rechte Auge, PD (L) bedeutet die
              monokulare PD für das linke Auge. Eine monokulare PD wird als zwei Zahlen geschrieben,
              zum Beispiel „32/30", „32" repräsentiert die PD für das rechte Auge und „30" für das
              linke Auge.
              <br />`}
              {`· Manchmal wird PD als „62/59" geschrieben oder sie werden mit „Fern" und „Nah"
              bezeichnet. Ihre PD wird normalerweise für die Fernsicht gemessen, die in diesem
              Beispiel „Fern-PD" oder „62" ist. Für Lesebrillen messen Ärzte im Beispiel Ihre
              „Nah-PD" oder „59".`}
            </div>
            <div className="text-sm font-normal text-gray-800 leading-24">
              {`Geben Sie immer Ihre „Fern-PD" für Fernsichtbrillen ein und geben Sie Ihre „Nah-PD"
              nur für Ihre Lesebrille ein. Für die meisten Menschen beträgt der Unterschied zwischen
              Fern- und Nah-PD etwa 2-3 mm.`}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// =================================================================
// 2. 移动端组件 (根据您提供的 Vue 模板生成)
// =================================================================
const MeasureDE_Mobile: React.FC = () => {
  return (
    <div className="w-full px-4 py-9">
      <h2 className="text-[28px] font-bold text-gray-800 mb-2 mt-[0px] mb-[20px]">
        So messen Sie die Pupillendistanz (PD)
      </h2>
      <p className="text-sm text-gray-800 leading-20 mb-[20px]">
        Die Pupillendistanz ist der Abstand von der Pupillenmitte bis zur Mitte der Nase. Dieser
        Wert wird in Millimeter (mm) angegeben. Bei Gleitsichtbrillen empfehlen wir dringend die
        Abmessung der PD-Werte durch einen Optiker oder Augenarzt, da bei kleinsten Abweichungen
        kein optimales Sehergebnis garantiert werden kann.
      </p>

      {/* Download */}
      <div className="flex flex-col items-center bg-gray-100 pt-[40px] pb-[44px] px-[22px] mb-8">
        <div className="text-sm mb-[30px] w-full">Laden Sie ein PD-Lineal herunter</div>
        <a
          rel="noopener noreferrer"
          href="https://common.xmslol.com/zeelool/pd/zeelool_de_pd_ruler.pdf"
          className="flex justify-center items-center w-[303px] h-[54px] bg-[#3c65c8] rounded-[27px] text-white text-base font-bold shadow-[0px_2px_12px_0px_rgba(60,101,200,0.53)]"
        >
          <Image
            src={'/static-page/guide-tips/download.png'}
            alt="Download"
            width={18}
            height={18}
            className="mr-2.5"
          />
          Klick hier
        </a>
      </div>

      {/* Mirror */}
      <div className="mb-[20px]">
        <h3 className="text-sm font-bold mb-5">Messen Sie es vor einem Spiegel</h3>
        <Image
          src="/static-page/guide-tips/pd/measure-mirror.png"
          alt="Mirror measurement"
          width={354}
          height={180}
          className="w-full h-auto"
        />
      </div>

      {/* Friend Help */}
      <h3 className="text-sm font-bold text-center my-8 mb-[20px]">
        Messen Sie Ihre Pupillendistanz mit der Hilfe eines Freundes
      </h3>

      {/* Step 1 */}
      <div className="bg-white shadow-[0px_0px_11px_0px_rgba(175,175,175,0.57)] pt-[16px] pb-0 px-[22px] mb-[20px]">
        <div className="flex mb-4 flex-col">
          <div className="w-1/5 text-xs font-bold">Schritt 1:</div>
          <br />
          <div className="w-4/5 text-xs leading-tight mb-[16px]">
            Stellen Sie sich mit einem Freund zu Ihnen, schauen Sie geradeaus und setzen Sie das
            Lineal auf den Nasenrücken.
          </div>
        </div>
        <Image
          src="/static-page/guide-tips/pd/step1.png"
          alt="Step 1"
          width={304}
          height={136}
          className="w-full h-auto"
        />
      </div>

      {/* Step 2 */}
      <div className="bg-white shadow-[0px_0px_11px_0px_rgba(175,175,175,0.57)] pt-[16px] pb-0 px-[22px] mb-[20px]">
        <div className="flex mb-4 flex-col">
          <div className="w-1/5 text-xs font-bold">Schritt 2:</div>
          <br />
          <div className="w-4/5 text-xs leading-tight mb-[16px]">
            Schließen Sie Ihr linkes Auge und lassen Sie Ihren Freund die 0 mm über der Mitte Ihrer
            rechten Pupille ausrichten.
          </div>
        </div>
        <Image
          src="/static-page/guide-tips/pd/step2.png"
          alt="Step 2"
          width={304}
          height={136}
          className="w-full h-auto"
        />
      </div>

      {/* Step 3 */}
      <div className="bg-white shadow-[0px_0px_11px_0px_rgba(175,175,175,0.57)] pt-[16px] pb-0 px-[22px] mb-[20px]">
        <div className="flex mb-4 flex-col">
          <div className="w-1/5 text-xs font-bold">Schritt 3:</div>
          <br />
          <div className="w-4/5 text-xs leading-tight mb-[16px]">
            Schließen Sie Ihr rechtes Auge und öffnen Sie das linke. Lassen Sie dann Ihren Freund
            den Messwert direkt über Ihrer linken Pupille notieren. Das wird Ihre PD sein.
          </div>
        </div>
        <Image
          src="/static-page/guide-tips/pd/step3.png"
          alt="Step 3"
          width={304}
          height={136}
          className="w-full h-auto"
        />
      </div>

      {/* Step 4 */}
      <div className="bg-white shadow-[0px_0px_11px_0px_rgba(175,175,175,0.57)] pt-[16px] pb-0 px-[22px] mb-[20px]">
        <div className="flex mb-4 flex-col">
          <div className="w-1/5 text-xs font-bold">Schritt 4:</div>
          <br />
          <div className="w-4/5 text-xs leading-tight mb-[16px]">
            Um eine PD mit hoher Genauigkeit zu messen, führen Sie dies bitte dreimal durch und
            nehmen Sie eine durchschnittliche Anzahl davon als endgültige PD-Messung
          </div>
        </div>
        <Image
          src="/static-page/guide-tips/pd/step4.png"
          alt="Step 4"
          width={304}
          height={136}
          className="w-full h-auto"
        />
      </div>

      {/* Notes */}
      <div className="mb-[20px]">
        <div
          className="text-xs font-bold text-gray-800 mb-[16px]"
          style={{ fontFamily: 'var(--font-bricolage-bold)' }}
        >
          Anmerkungen:
        </div>
        <div className="text-xs text-gray-800 leading-tight space-y-2 leading-20">
          <div>1. Die durchschnittliche PD der Erwachsener liegt zwischen 54 mm und 78 mm</div>
          <div>
            2. Für diejenigen, die Gleitsichtgläser benötigen, empfehlen wir dringend, diese
            Informationen von Ihrem Optiker zu erhalten, um die Genauigkeit Ihrer Brille
            sicherzustellen.
          </div>
          <div>
            3. Ihre PD kann auf drei Arten geschrieben werden:
            <br />
            {`· PD geschrieben als „64", bezeichnet die binokulare PD, die für beide Augen gilt.`}
            <br />
            {`· PD (R) bedeutet die monokulare PD für das rechte Auge, PD (L) bedeutet die
            monokulare PD für das linke Auge. Eine monokulare PD wird als zwei Zahlen geschrieben,
            zum Beispiel „32/30", „32" repräsentiert die PD für das rechte Auge und „30" für das
            linke Auge.`}
            <br />
            {`· Manchmal wird PD als „62/59" geschrieben oder sie werden mit „Fern" und „Nah"
            bezeichnet. Ihre PD wird normalerweise für die Fernsicht gemessen, die in diesem
            Beispiel „Fern-PD" oder „62" ist. Für Lesebrillen messen Ärzte im Beispiel Ihre „Nah-PD"
            oder „59".`}
          </div>
          <div className="mt-[20px]">
            {` Geben Sie immer Ihre „Fren-PD“ für Fernsichtbrillen ein und geben Sie Ihre „Nah-PD“ nur
            für Ihre Lesebrille ein. Für die meisten Menschen beträgt der Unterschied zwischen Fern-
            und Nah-PD etwa 2-3 mm.`}
          </div>
        </div>
      </div>
    </div>
  );
};

export const MeasureDE: React.FC = () => {
  const isMobile = useMediaQuery('(max-width:1024px)');
  return isMobile ? <MeasureDE_Mobile /> : <MeasureDE_PC />;
};

export default MeasureDE;
